﻿export interface IDutyOfficer {
    id: number;
    name: string;
    initials: string;
    email: string;
    phoneNumber: string;
}